import { useEffect, useState } from 'react';
import { loadFeatureSettings } from '../../global/featureFlags';

// ENG-3659: whether the organization has Awaiting Provider, from the features
// payload (feature_settings.awaiting_provider). False until it is known. Kept
// apart from awaitingProvider.js so the row chip, which every inbox column
// renders, doesn't pull in the feature-flag module.
const useAwaitingProviderEnabled = () => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let mounted = true;
    loadFeatureSettings('awaiting_provider').then((settings) => {
      if (mounted) setEnabled(settings?.enabled === true);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);
  return enabled;
};

export default useAwaitingProviderEnabled;
